// SILVEX — shared behavior

// Scroll reveals
const io = new IntersectionObserver((entries) => {
  for (const e of entries) {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }
}, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
document.querySelectorAll('.reveal').forEach(el => io.observe(el));

// Sticky buy bar: show after hero leaves, hide over offer/final sections
const buybar = document.getElementById('buybar');
if (buybar) {
  const hero = document.querySelector('.hero-scrub, .hero, .product-layout');
  const hiders = document.querySelectorAll('[data-hide-buybar]');
  let heroGone = false;
  const hiderVisible = new Map();
  const sync = () => {
    const anyHider = [...hiderVisible.values()].some(Boolean);
    buybar.classList.toggle('show', heroGone && !anyHider);
  };
  if (hero) {
    new IntersectionObserver(([e]) => { heroGone = !e.isIntersecting; sync(); }, { threshold: 0 }).observe(hero);
  }
  hiders.forEach(el => {
    hiderVisible.set(el, false);
    new IntersectionObserver(([e]) => { hiderVisible.set(el, e.isIntersecting); sync(); }, { threshold: .15 }).observe(el);
  });
}

// FAQ accordions: close others on open (scoped per [data-accordion] group)
document.querySelectorAll('[data-accordion]').forEach(group => {
  const items = group.querySelectorAll('details');
  items.forEach(d => {
    d.addEventListener('toggle', () => {
      if (d.open) items.forEach(o => { if (o !== d) o.open = false; });
    });
  });
});

// Hero video — scrubbed to scroll on both desktop (landscape) and mobile (portrait);
// poster-only under reduced motion.
const heroScrub = document.querySelector('.hero-scrub');
const heroVideo = heroScrub && heroScrub.querySelector('.hero-video');
if (heroVideo) {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile = matchMedia('(max-width: 768px)').matches;

  if (reduce) {
    // Hold the poster / first frame — no motion.
  } else {
    // Mobile gets the dedicated portrait (9:16) rendition.
    if (mobile && heroVideo.dataset.mobileSrc) {
      heroVideo.poster = heroVideo.dataset.mobilePoster || heroVideo.poster;
      heroVideo.src = heroVideo.dataset.mobileSrc;
      heroVideo.load();
    }
    heroVideo.pause();

    // iOS only renders frames from currentTime seeks after the video has decoded
    // once — prime it with a muted play/pause on first touch.
    if (mobile) {
      const prime = () => {
        const p = heroVideo.play();
        if (p && p.then) p.then(() => heroVideo.pause()).catch(() => {});
        else heroVideo.pause();
      };
      window.addEventListener('touchstart', prime, { once: true, passive: true });
      window.addEventListener('pointerdown', prime, { once: true, passive: true });
    }

    let duration = 6, target = 0, cur = 0, start = 0, dist = 1, ready = false;
    const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
    const measure = () => {
      start = heroScrub.offsetTop;
      dist = Math.max(1, heroScrub.offsetHeight - window.innerHeight);
    };
    const onMeta = () => { duration = heroVideo.duration || 6; ready = true; measure(); };
    if (heroVideo.readyState >= 1) onMeta();
    else heroVideo.addEventListener('loadedmetadata', onMeta);
    window.addEventListener('resize', measure, { passive: true });

    const tick = () => {
      const p = clamp((window.scrollY - start) / dist, 0, 1);

      // Camera push-in tied to scroll.
      target = p * duration;
      cur += (target - cur) * 0.15;               // lerp → weighty, filmic scrub
      if (Math.abs(target - cur) < 0.004) cur = target;
      if (ready && heroVideo.readyState >= 1) {
        try { heroVideo.currentTime = cur; } catch (e) { /* seek in progress */ }
      }

      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }
}

// Cinematic sections — each video plays through ONCE when scrolled into view
// and holds its last frame (no loop). Reduced motion keeps the posters.
const cineVideos = [...document.querySelectorAll('.fc-video')];
if (cineVideos.length && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const wantMobile = matchMedia('(max-width: 768px)').matches;
  cineVideos.forEach(v => {
    // Phones get the dedicated portrait rendition.
    if (wantMobile && v.dataset.mobileSrc) {
      v.poster = v.dataset.mobilePoster || v.poster;
      v.src = v.dataset.mobileSrc;
      v.load();
    }
    // Warm-up: start the full download one viewport ahead of the section, so
    // preload="metadata" saves initial page weight without a buffering pause.
    new IntersectionObserver(([e], obs) => {
      if (e.isIntersecting) {
        v.preload = 'auto';
        v.load();
        obs.disconnect();
      }
    }, { rootMargin: '100% 0px' }).observe(v);
    if ('loop' in v.dataset) {
      // Ambient loop (e.g. rain): plays while on screen, pauses off screen.
      v.loop = true;
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting) v.play().catch(() => {});
        else v.pause();
      }, { threshold: 0.25 }).observe(v);
    } else {
      // One-shot: plays through once and holds the final frame.
      new IntersectionObserver(([e], obs) => {
        if (e.isIntersecting) {
          v.play().catch(() => {});
          obs.disconnect();
        }
      }, { threshold: 0.35 }).observe(v);
    }
  });
}

// Ambient section videos — play only while on screen (battery + data)
document.querySelectorAll('video[data-ambient]').forEach(v => {
  v.muted = true; // belt & suspenders for autoplay policies
  new IntersectionObserver(([e]) => {
    if (e.isIntersecting) v.play().catch(() => {});
    else v.pause();
  }, { threshold: 0.2 }).observe(v);
});

// Product gallery
const mainImg = document.getElementById('gallery-main');
const mainVid = document.getElementById('gallery-video');
if (mainImg) {
  document.querySelectorAll('.thumb').forEach(t => {
    t.addEventListener('click', () => {
      document.querySelectorAll('.thumb').forEach(o => o.classList.remove('active'));
      t.classList.add('active');
      if (t.dataset.video && mainVid) {
        mainImg.style.display = 'none';
        mainVid.style.display = 'block';
        if (mainVid.getAttribute('src') !== t.dataset.video) mainVid.src = t.dataset.video;
        mainVid.play().catch(() => {});
        return;
      }
      if (mainVid) { mainVid.pause(); mainVid.style.display = 'none'; }
      mainImg.style.display = '';
      // srcset overrides src, so keep it in sync with the selected photo.
      // The thumb's own <img> carries the same srcset the main frame needs.
      mainImg.srcset = t.querySelector('img').srcset;
      mainImg.src = t.dataset.full;
      mainImg.alt = t.querySelector('img').alt;
    });
  });
}

// Pain story — one full-screen stage, three scenes (index):
// scene 1 (beats 1-4): pain statements stack up · scene 2 (beat 5 + dwell):
// the wall recedes while "Sound familiar?" covers it · scene 3 (beats 6-7):
// everything clears, "Never again." lands alone in the same spot.
const deck = document.querySelector('.deck-scroll');
if (deck) {
  const lines = [...deck.querySelectorAll('.pw-item')];
  const wall = deck.querySelector('.pain-wall');
  const deckHead = deck.querySelector('.deck-head');
  const answer = deck.querySelector('.deck-answer');
  const reduceDeck = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceDeck || !lines.length || !deckHead || !answer) {
    document.body.classList.add('deck-static');
  } else {
    const units = lines.length + 3; // 4 statements + headline + exit + answer
    const clampD = (v, a, b) => Math.min(b, Math.max(a, v));
    const easeOut = f => 1 - Math.pow(1 - f, 3);
    const desktop = () => innerWidth > 768;
    let dStart = 0, dDist = 1;
    const measureDeck = () => {
      dStart = deck.offsetTop;
      dDist = Math.max(1, deck.offsetHeight - window.innerHeight);
    };

    const renderDeck = () => {
      measureDeck(); // layout can shift as hero media loads — cheap on this page
      // Start the story while the section is still entering the viewport,
      // so the first card is already flying in as the stage pins.
      const lead = window.innerHeight * 0.55;
      const p = clampD((window.scrollY - dStart + lead) / (dDist * 0.88 + lead), 0, 1) * units;
      const headIn = easeOut(clampD(p - lines.length, 0, 1));
      // 0.4-unit dwell on the covered wall before the stage clears.
      const exit = easeOut(clampD((p - lines.length - 1.4) / 0.6, 0, 1));

      lines.forEach((el, i) => {
        const f = clampD(p - i, 0, 1);
        const ease = easeOut(f);
        const dir = i % 2 ? 1 : -1;
        // Cards fly in from their own side and settle on a slight resting tilt.
        el.style.transform = `translate(${(1 - ease) * dir * 8}vw, ${(1 - ease) * 26}px) rotate(${(1 - ease) * dir * 4 - dir * 0.7}deg)`;
        el.style.opacity = String(f);
      });

      // Scene 2: the wall recedes behind the headline, then leaves with it.
      wall.style.opacity = String((1 - headIn * 0.85) * (1 - exit));
      wall.style.filter = (desktop() && headIn > 0.02) ? `blur(${headIn * 7}px)` : 'none';
      wall.style.transform = `scale(${1 - headIn * 0.04})`;

      deckHead.style.opacity = String(headIn * (1 - exit));
      deckHead.style.transform = `translateY(${(1 - headIn) * 30 - exit * 26}px) scale(${0.94 + headIn * 0.06})`;

      // Scene 3: the answer, alone.
      const fA = easeOut(clampD(p - lines.length - 2, 0, 1));
      answer.style.opacity = String(fA);
      answer.style.transform = `translateY(${(1 - fA) * 36}px) scale(${0.92 + fA * 0.08})`;
    };
    // Scroll events are rAF-aligned in modern browsers — render directly.
    window.addEventListener('scroll', renderDeck, { passive: true });
    window.addEventListener('resize', renderDeck, { passive: true });
    // Layout shifts (hero media loading) move the deck without a scroll event.
    new ResizeObserver(renderDeck).observe(document.body);
    renderDeck();
  }
}
